import React, { Component } from 'react'
import Trend from 'react-trend'

import SelectCountry from './micro/SelectCountry'

import { getRandomInt, randomDataArr } from '../helpers'

import './SegmentData.css'

import Map from './Map'

const Checkbox = ({
  name,
  value,
  checked,
  onChange,
  label,
}) => (
  <label className="segment-checkbox">
    <input className="segment-checkbox__input" type="checkbox" 
      name={name} 
      value={value}
      checked={checked} 
      onChange={onChange} />
    <div className="segment-checkbox__label">{label}</div>
  </label>
)

class SegmentData extends Component {
  state = {
    name: '',
    search: this.props.search || '',
    data: randomDataArr(12),
    request: 'jazz & blues music',
    country: '',
    state: '',
    minAge: 18,
    maxAge: 34,
    influence: 14,
    conversion: 21,
    minSpending: 50,
    maxSpending: 100,
    attending: 1,
    gender: [
      {text: 'Men', label: 'Men', value: true},
      {text: 'Women', label: 'Women', value: true},
    ],
    medium: [
      {text: 'Email', label: 'Email', value: true},
      {text: 'SMS', label: 'SMS/Text', value: true},
      {text: 'Push', label: 'Push Messages', value: true},
      {text: 'Social', label: 'Social Media', value: true},
    ],
    total: 14701147,
    reach: 14701147,
  }

  componentDidMount() {
    // console.log('componentDidMount', this.props.search);
    this.setState({ search: this.props.search });
  }

  componentWillReceiveProps(nextProps) {
    // console.log('componentWillReceiveProps', nextProps.search);
    this.setState({ search: nextProps.search });
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log('componentDidUpdate')
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.name === this.state.name) return true;
  }

  name = () => {
    const state = this.state;
    let who;
    let from = '';
    const genders = state.gender.filter(({ value }) => value).length;
    if (genders > 1) {
      who = 'Everyone';
    } else {
      who = state.gender.find(({ value }) => value).label;
    }
    if (state.country) {
      from = ` from ${state.country}`;
    }
    return `${who}${from} who likes ${state.search}`
  }

  calculateReach = (name, value) => {
    const state = { ...this.state, [name]: value };
    let people = state.total;

    // console.log(people)

    if (state.country) {
      people -= (state.country.length)/100*people; 
      // console.log('country', people)
    }

    if (state.city) {
      people -= (100-state.city.length)/100*people; 
      // console.log('city', people)
    }
    
    people -= +state.influence/100*people;
    // console.log('influence', people)
    people -= +state.conversion/100*people;
    // console.log('conversion', people)

    state.medium.forEach(function(item) {
      if (!item.value) {
        switch (item.text) {
          case 'Email':
            // console.log('people - 90%')
            people -= 90/100*people;
            break;
          case 'SMS':
            // console.log('people - 33%')
            people -= 33/100*people;
            break;
          case 'Push':
            // console.log('people - 44%')
            people -= 44/100*people;
            break;
          case 'Social':
            // console.log('people - 80%')
            people -= 80/100*people;
            break;
          default:
            break;
        }
      }
    });
    // console.log('mediums', people)

    const age = state.maxAge - state.minAge;
    people -= (100-age*4)/100*people;
    // console.log('age', people)

    const spending = (state.maxSpending - state.minSpending) / 100;
    people -= (spending*10)/100*people;
    // console.log('spending', people)
    
    people /= +state.attending || 1;
    // console.log('attending', people)

    const genders = state.gender.filter(({ value }) => value);
    if (genders.length < 2) {
      people = genders[0].label === 'Men' ? Math.round(people/1.8) : Math.round(people/2.2);;
    }
    // console.log('genders', people)

    return Math.round(people);
  }

  adjustData = (data) => {
    const d = getRandomInt(0,1);
    return data.map(function(item) {
      if (d) {
        item += getRandomInt(item,10);
      } else {
        item -= getRandomInt(0,item);
      }
      return item;
    });
  }

  handleChange = (ev) => {
    const name = ev.target.name;
    const value = ev.target.type === 'checkbox' 
      ? ev.target.checked
      : ev.target.value;

    const data = this.adjustData([...this.state.data]);
    const reach = this.calculateReach(name, value)

    this.setState({ [name]: value, data, reach })
  }

  handleCheckbox = (ev) => {
    const target = ev.target;
    let array = [...this.state[target.name]];
    const last = array.filter(({ value }) => value).length === 1;
    if (last && !target.checked) return;
    array = array.map((item, i) => +target.value === i 
      ? {...item, value: target.checked } 
      : item 
    )

    const data = this.adjustData([...this.state.data]);
    const reach = this.calculateReach([target.name], array)

    this.setState({ [target.name]: array, data, reach })
  }

  handleKeyUp = (ev) => {
    const name = ev.target.name;
    const value = ev.target.value;
    if (ev.key === 'Enter') {
      const data = this.adjustData([...this.state.data]);
      const reach = this.calculateReach(name, value)
      this.setState({[name]: value, data, reach })
    }
  }

  renderReach = (reach) => {
    const g = this.state.gender.filter(({value}) => value);
    if (g.length === 2) {
      const m = Math.round(reach/1.8);
      const w = Math.round(reach/2.2);
      return [
        <div className="ai__data ai__peoples" key={1}>
        Total <b>{reach.toLocaleString()}</b> 
        </div>,
        <div className="ai__data ai__unengaged" key={2}>
          Men {m.toLocaleString()}
        </div>,
        <div className="ai__data ai__regulars" key={3}>
          Women {w.toLocaleString()}
        </div>
      ]
    } else if (g[0].label === 'Men') {
      return (
        <div className="ai__data ai__unengaged">
          Men {reach.toLocaleString()}
        </div>
      )
    } else {
      return (
        <div className="ai__data ai__regulars">
          Women {reach.toLocaleString()}
        </div>
      )
    }
  }

  render() {
    const reach = this.state.reach;

    const n = getRandomInt(0,25);
    const u = getRandomInt(n,100-n);
    const r = 100 - n - u;

    function width(value) {
      return { width: `${ value.toString().length * 22 }px`}
    }

    function perc(p) {
      return Math.round(p/100*reach).toLocaleString();
    }

    function gender(arr) {
      const g = arr.filter(({value}) => value);
      if (g.length === 2) {
        const m = Math.round(reach/1.8);
        const w = Math.round(reach/2.2);
        return `${m.toLocaleString()}(M)/${w.toLocaleString()}(W)`;
      }
      return ''
    }

    return (
      <div className="segment-data">
        <div className="autosuggest__item segment-header" onClick={this.props._toggleFullView}>
          <div className="segment-header__side">
            <input className="ai__input" type="text"
              placeholder={this.name()} 
              name="name"
              // value={this.state.name}
              onChange={this.handleChange} />
          </div>
          {/* <div className="segment-header__total">
            Total <b>{reach.toLocaleString()}</b> fans <div className="segment-header__total-gender">{gender(this.state.gender)}</div>
          </div> */}
          {/* <div className="segment-header__side ai">
            <div className="ai__data ai__new">New {n}%</div>
            <div className="ai__data ai__unengaged">Unengaged {u}%</div>
            <div className="ai__data ai__regulars">Regulars {r}%</div>
            <div className="ai__button" onClick={this.props.toggleFullView}>Save</div>
          </div> */}
          <div className="segment-header__side ai">
            {this.renderReach(reach)}
            <div className="ai__button" onClick={this.props.toggleFullView}>Save</div>
          </div>
        </div>

        <div className="segment-distr">
          { this.state.medium[3].value && 
            [
              <div className="fa fa--mod fa-facebook" key="0">{perc(60)}</div>,
              <div className="fa fa--mod fa-instagram" key="1">{perc(40)}</div>,
              <div className="fa fa--mod fa-twitter" key="2">{perc(30)}</div>,
              <div className="fa fa--mod fa-google" key="3">{perc(60)}</div>,
              <div className="fa fa--mod fa-youtube-play" key="4">{perc(51)}</div>,
              <div className="fa fa--mod fa-snapchat-ghost" key="5">{perc(21)}</div>,
              <div className="fa fa--mod fa-spotify" key="6">{perc(14)}</div>,
            ]
          }
          { this.state.medium[0].value && <div className="fa fa--mod fa-envelope">{perc(90)}</div> }
          { this.state.medium[1].value && <div className="fa fa--mod fa-bell">{perc(44)}</div> }
          { this.state.medium[2].value && <div className="fa fa--mod fa-commenting">{perc(33)}</div> }
        </div> 

        <Map/>

        {/* <Trend
          smooth
          autoDraw
          autoDrawDuration={3000}
          autoDrawEasing="ease-out"
          data={this.state.data}
          gradient={['#00c6ff', '#F0F', '#FF0']}
          radius={10}
          strokeWidth={1}
          strokeLinecap={'butt'}
          padding={2}
        /> */}
        
        <div className="columns segment__tuner">
          <div className="column column--fb">
            <div className="segment-stat">
              <div className="segment-stat__label">{'Age'}</div>
              <input className="segment-stat__input" style={width(this.state.minAge)}
                type="number" min="0" max={+this.state.maxAge - 1}
                name="minAge"
                value={this.state.minAge}
                onChange={this.handleChange} />
              <div className="segment-stat__value">-</div>
              <input className="segment-stat__input" style={width(this.state.maxAge)}
                type="number" min={+this.state.minAge + 1}
                name="maxAge"
                value={this.state.maxAge}
                onChange={this.handleChange} />
            </div>
          </div>
          <div className="column column--fb">
            <div className="segment-stat">
              <div className="segment-stat__label">{'Influencer \n score'}</div>
              <input className="segment-stat__input" style={width(this.state.influence)}
                type="number" min="0" max="100"
                name="influence"
                value={this.state.influence}
                onChange={this.handleChange} />
              <div className="segment-stat__value" style={{color: '#e91e63'}}>%</div>
            </div>
          </div>
          <div className="column column--fb">
            <div className="segment-stat">
              <div className="segment-stat__label">{'Fansifter \n Conversion rate'}</div>
              <input className="segment-stat__input" style={width(this.state.conversion)}
                type="number" min="0" max="100"
                name="conversion"
                value={this.state.conversion}
                onChange={this.handleChange} />
              <div className="segment-stat__value" style={{color: '#03A9F4'}}>%</div>
            </div>
          </div>
          <div className="column column--fb">
            <div className="segment-stat">
              <div className="segment-stat__label">{'Monthly \n spending'}</div>
              {/* <div className="segment-stat__value">${this.state.spending[0]}-${this.state.spending[1]}</div> */}
              <div className="flex" style={{color: '#00ff0c'}}>
                <div className="segment-stat__value">$</div>
                <input className="segment-stat__input" style={width(this.state.minSpending)}
                  type="number" min="0" max={+this.state.maxSpending - 1}
                  name="minSpending"
                  value={this.state.minSpending}
                  onChange={this.handleChange} />
                <div className="segment-stat__value">-</div>
                <div className="segment-stat__value">$</div>
                <input className="segment-stat__input" style={width(this.state.maxSpending)}
                  type="number" min={+this.state.minSpending + 1}
                  name="maxSpending"
                  value={this.state.maxSpending}
                  onChange={this.handleChange} />
              </div>
            </div>
          </div>
          <div className="column column--fb">
            <div className="segment-stat">
              <div className="segment-stat__label">{'Visited \n events'}</div>
              {/* <div className="segment-stat__value">{this.state.attending}</div> */}
              <input className="segment-stat__input" style={width(this.state.attending)}
                type="number" min="0" max="14"
                name="attending"
                value={this.state.attending}
                onChange={this.handleChange} />
            </div>
          </div>
        </div>

        <div className="segment__settings">
          <div>
            <SelectCountry className="segment__input segment__input--country"
              name="country" 
              onChange={this.handleChange} />
            <input className="segment__input" type="text"
              placeholder="State/Province, City or ZIP Code"
              onKeyUp={this.handleKeyUp}
              name="city" />
          </div>
          <div className="flex-center">
            {this.state.gender.map(({ label, value }, i) => 
              <Checkbox key={i}
                label={label} 
                name="gender" 
                value={i} 
                checked={value}
                onChange={this.handleCheckbox} />
            )}
          </div>
          <div className="flex-center">
            {this.state.medium.map(({ label, value }, i) => 
              <Checkbox key={i}
                label={label} 
                name="medium" 
                value={i} 
                checked={value}
                onChange={this.handleCheckbox} />
            )}
          </div>
        </div>
        {/* <div className="flex-between">
          <input className="segment-stat__input" type="text" value={this.name()} />
          <div className="segment-stat__value">{this.audience().toLocaleString()} Fans</div>
          <button className="button">Save</button>
        </div> */}
      </div>
    )
  }
}

export default SegmentData


// WEBPACK FOOTER //
// ./src/components/SegmentData.js